export default {"src":"/_next/static/media/GOOD.9e1934de.svg","height":18,"width":18};